import React from "react";
import Header from "../Header";
import "./assistant.css";
import reactDom from "react-dom";
import {
  Fulltime_Request,
  Users,
  PartimeRequest,
  Guarantors,
  Applied_jobs,
} from "./List";
import { CSSTransition } from "react-transition-group";
// import Scroll from "./Scroll";
import { getDatabase, ref, onValue } from "firebase/database";
import { Partime } from "../request/Request";
import { useState } from "react";
import { useFlutterwave, closePaymentModal } from "flutterwave-react-v3";

const getDatabasedatausers = (email, password) => {
  if (email == "househelps@gmail.com" && password == "Barcode1jr.") {
    localStorage.setItem("username", "househelps@gmail.com");

    console.log(localStorage);
    renderAdmin();
  } else {
    document.querySelector("#data").innerHTML =
      "incorrect username && password";
  }
};

const getformdata2 = (e) => {
  var email = document.querySelector("#email").value;
  var password = document.querySelector("#password").value;

  console.log(email, password);

  if (email !== "" && password !== "") {
    document.querySelector("#data").innerHTML = "waiting For Network";
    getDatabasedatausers(email, password);

    document.querySelector("#email").value = "";
    document.querySelector("#password").value = "";
  } else {
    document.querySelector("#data").innerHTML =
      "incorrect username && password";
  }
};

class LoginA extends React.Component {
  componentDidMount() {
    if (localStorage.getItem("username") == "househelps@gmail.com") {
      renderAdmin();
    }
    var span = document
      .querySelector(".spnn")
      .addEventListener("click", () => {});

    var logologo = document.querySelector("#logo-logo");
    logologo.style.display = "none";
  }

  render() {
    return (
      <div className="div">
        <CSSTransition
          timeout={500}
          transitionname="carousel"
          transitionappear="true">
          <div>
            <h1 style={{ textAlign: "center" }}>Login</h1>
            <form name="Login">
              <p>Email</p>
              <input type="email" id="email" required></input>

              <p>Password</p>
              <input type="password" id="password" required></input>

              <input
                type="submit"
                value="Submit"
                id="submit_button_l"
                onClick={getformdata2}
                style={{}}></input>
              <div id="data" style={{ color: "red" }}>
                {" "}
              </div>

              <div>
                <span className="spnn">
                  Don't have an Account , {" " + "   " + " "}{" "}
                  <span style={{ color: "green" }}> Signup now</span>
                </span>
              </div>
            </form>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

class Assistant extends React.Component {
  constructor() {
    super();
    this.state = {
      jobs: {},
    };
  }

  componentDidMount() {
    var view = document.querySelector("#name");
    function load() {
      sessionStorage.setItem("name", "sadam");
      if (
        sessionStorage.getItem("name") == "" ||
        sessionStorage.getItem("name") == null
      ) {
        window.location.href = "/Login";
      }

      console.log(view);
    }
    load();

    // var url = "https://api.webpushr.com/v1/notification/send/all";

    // var xhr = new XMLHttpRequest();
    // xhr.open("POST", url);

    // xhr.setRequestHeader("webpushrKey", "521b8ccaf952c3572d26b42d8a218f45");
    // xhr.setRequestHeader("webpushrAuthToken", "48589");
    // xhr.setRequestHeader("Content-Type", "application/json");
    // xhr.setRequestHeader('Access-Control-Allow-Origin', '*')
    // xhr.onreadystatechange = function () {
    //    if (xhr.readyState === 4) {
    //       console.log(xhr.status);
    //       console.log(xhr.responseText);
    //    }};

    // var data = `{"title":"A new Job Request","message":${sessionStorage.getItem("name")},"target_url":"https://www.househelps.org","action_buttons":[{"title":"Demo", "url":"https://www.househelps.org"},{"title":"Pricing", "url":"https://www.househelps.org"}]}`;

    // xhr.send(data);
  }

  render() {
    return (
      <div>
        <div style={{margin:"20px auto",textAlign:"center"}}>
          <button onClick={()=>{window.location.href="./asignup"}}>
            register a profile and get instant Bonus
          </button>
          <button>
           view registered profiles
          </button>
        </div>

      
      <div>
       
        <p className="names" id="nn3">
          {" "}
        </p>
        {/* <div id="container">
          <div className="personal information" style={{ textAlign: "left" }}>
            <p className="pd">
              Fullname:{" " + sessionStorage.getItem("name") + " "}{" "}
              {sessionStorage.getItem("lastname")}
              <br></br>
            </p>
            <p className="pd">
              State Of Origin: {"" + sessionStorage.getItem("SOO")}
            </p>
            <p className="pd">Age: {"" + sessionStorage.getItem("age")}</p>
            <p className="pd">
              Jobtype: {"" + sessionStorage.getItem("jobtype")}
            </p>
            <p className="pd">Status: Unemployed</p>
            <p className="pd">
              Phone Number: {"" + sessionStorage.getItem("pnumber")}
            </p>
          </div>
          <div id="data" style={{ display: "none" }}></div>
        </div> */}
        <div id="available_jobs">
          <h2 style={{ textAlign: "center" }} id="">
            Registered Profiles
          </h2>
          {/* <Scroll> */}
          <Fulljobs />
          {/* </Scroll> */}
        </div>
      </div>
      </div>
    );
  }
}

class Fulljobs extends React.Component {
  constructor() {
    super();
    this.state = {
      Fulltime_Request: [],
      applied_jobs: [],
      customers: [],
      guarantors: [],
      partimeRequest: [],
      users: [],

      Fulltime_Request2: [],
      applied_jobs2: [],
      customers2: [],
      guarantors2: [],
      partimeRequest2: [],
      users2: [],
    };

    function searchfunction() {
      console.log("input");
    }
  }

  componentDidMount() {
    var fulljobsarray = [];
    var applied_jobsarray = [];
    var customersarray = [];
    var guarantorsarray = [];
    var partimearray = [];
    var usersarray = [];

    const db = getDatabase();
    const starCountRefF = ref(db, "Fulltime_Request/");

    const starCountRefA = ref(db, "applied_jobs/");
    const starCountRefC = ref(db, "customers/");
    const starCountRefG = ref(db, "guarantors/");
    const starCountRefP = ref(db, "partimeRequest/");
    const starCountRefU = ref(db, "users/");

    onValue(starCountRefF, (snapshot) => {
      snapshot.forEach((element) => {
        fulljobsarray.push(element.val());
      });
    });
    onValue(starCountRefA, (snapshot) => {
      snapshot.forEach((element) => {
        applied_jobsarray.push(element.val());
      });
    });
    onValue(starCountRefC, (snapshot) => {
      snapshot.forEach((element) => {
        customersarray.push(element.val());
      });
    });
    onValue(starCountRefG, (snapshot) => {
      snapshot.forEach((element) => {
        guarantorsarray.push(element.val());
      });
    });
    onValue(starCountRefP, (snapshot) => {
      snapshot.forEach((element) => {
        partimearray.push(element.val());
      });
    });
    onValue(starCountRefU, (snapshot) => {
      snapshot.forEach((element) => {
        usersarray.push(element.val());
      });
    });

    var fulljobsarray_reverse = fulljobsarray.reverse();
    var partimerequest_reverse = partimearray.reverse();
    this.setState({
      selectedJObs: fulljobsarray_reverse,
      Fulltime_Request: fulljobsarray,
      applied_jobs: applied_jobsarray,
      customers: customersarray,
      guarantors: guarantorsarray,
      partimeRequest: partimerequest_reverse,
      users: usersarray,
    });
  }

  render() {
    return (
      <div>
        <div
          style={{
            width: "300px",
            display: "block",
            textAlign: "center",
            margin: "0px auto",
          }}>
          <div style={{ width: "100%", display: "inline-flex" }}>
            <input
              id="searchinput"
              type="search"
              placeholder="search "
              onInput={() => {
                var searchparams = document.querySelector("#searchinput").value;
                var searchparams2 = searchparams.toLowerCase();
                console.log(searchparams, searchparams2);

                var newlistf = this.state.Fulltime_Request;
                var newlistg = this.state.guarantors;
                var newlista = this.state.applied_jobs;
                var newlistc = this.state.customers;
                var newlistp = this.state.partimeRequest;
                var newlistu = this.state.users;
                console.log(
                  newlistf,
                  newlistg,
                  newlista,
                  newlistc,
                  newlistp,
                  newlistu
                );
                var newlistf2 = [];
                var newlistg2 = [];
                var newlista2 = [];
                var newlistc2 = [];
                var newlistp2 = [];
                var newlistu2 = [];

                function collectsearchresultsf(joblist) {
                  var details =
                    joblist.firstname +
                    joblist.lastname +
                    joblist.states +
                    joblist.pnumber +
                    "job joblist fulltime";

                  if (details.toLowerCase().includes(searchparams2)) {
                    return newlistf2;
                  }
                }

                function collectsearchresultsg(guarantorlist) {
                  var details =
                    guarantorlist.Applicantemail +
                    guarantorlist.gpnumber +
                    guarantorlist.Applicantname +
                    guarantorlist.gfirstname +
                    guarantorlist.glastname +
                    "guarantor";
                  if (details.toLowerCase().includes(searchparams2)) {
                    return newlistg2;
                  }
                }

                function collectsearchresultsa(applies) {
                  var details =
                    applies.helpName +
                    applies.clientName +
                    applies.clientEmail +
                    applies.clientPnumber +
                    applies.helpNumber +
                    "applied apply";
                  if (
                    details.toLowerCase().includes(searchparams2.toLowerCase())
                  ) {
                    return newlista2;
                  }
                }
                function collectsearchresultsc(customer) {
                  var details =
                    customer.firstname +
                    customer.email +
                    customer.lastname +
                    "customers clients ";
                  if (details.toLocaleLowerCase().includes(searchparams2)) {
                    return newlistc2;
                  }
                }
                function collectsearchresultsp(partime) {
                  var details =
                    partime.customerName +
                    partime.customerEmail +
                    partime.customerAddress +
                    "partime";
                  if (details.includes(searchparams2)) {
                    return newlistp2;
                  }
                }
                function collectsearchresultsu(users) {
                  var details =
                    users.SOO +
                    users.firstname +
                    users.lastname +
                    users.email +
                    users.pnumber +
                    "worker" +
                    users.jobtype;
                  if (details.toLowerCase().includes(searchparams2)) {
                    console.log(users);
                    return newlistu2;
                  }
                }

                const selectedJObs = newlistf.filter(collectsearchresultsf);
                const selectedg = newlistg.filter(collectsearchresultsg);
                const selecteda = newlista.filter(collectsearchresultsa);
                const selectedc = newlistc.filter(collectsearchresultsc);
                const selectedp = newlistp.filter(collectsearchresultsp);
                const selectedu = newlistu.filter(collectsearchresultsu);

                var rselectedJObs = selectedJObs.reverse();
                var rselectedg = selectedg.reverse();
                var rselecteda = selecteda.reverse();
                var rselectedc = selectedc.reverse();
                var rselectedu = selectedu.reverse();
                var rselectedp = selectedp.reverse();
                this.setState({
                  Fulltime_Request2: rselectedJObs,
                  guarantors2: rselectedg,
                  applied_jobs2: rselecteda,
                  customers2: rselectedc,
                  partimeRequest2: rselectedp,
                  users2: rselectedu,
                });
                // this.setState({partimeRequest:partimerequest_reverses})
              }}></input>
            <br></br>
            <input style={{ width: "40%" }} type="submit"></input>
          </div>
        </div>

        {/* <Scroll> */}
        {this.state.partimeRequest2.map((data, index) => (
          <PartimeRequest buttondata={data} index={index} />
        ))}

        {this.state.applied_jobs2.map((data, index) => (
          <Applied_jobs buttondata={data} index={index} />
        ))}

        {this.state.Fulltime_Request2.map((data, index) => (
          <Fulltime_Request
            buttondata={data}
            kidsnum={data.kidsnum}
            index={index}
            firstname={data.firstname}
            lastname={data.lastname}
            address={data.address}
            state={data.state}
            pnumber={data.pnumber}
            jobtype={data.jobtype}
            email={data.email}
            date={data.date}
            Description={data.description}
            middlename={data.middlename}
          />
        ))}

        {this.state.users2.map((data, index) => (
          <Users buttondata={data} index={index} />
        ))}

        {this.state.guarantors2.map((data, index) => (
          <Guarantors buttondata={data} index={index} />
        ))}

        {/* </Scroll> */}
      </div>
    );
  }
}

const Donate = () => {
  var amount = sessionStorage.getItem("agreedAmount");
 

  
  var email = "customer@gmail.com";
  var request_date = sessionStorage.getItem("requestdate");

  var phonenumber = sessionStorage.getItem("customernumber");
  var name = sessionStorage.getItem("customername");
  var selectedcurrency = sessionStorage.getItem("selectedcurrency");
  console.log(request_date);
 

  return (
    <div>
      <div
        style={{
          width: "300px",
          display: "block",
          textAlign: "center",
          margin: "0px auto",
        }}>
        <h1>Donate</h1>
        <div style={{ width: "100%", display: "inline-flex" }}>
          <input
            id="searchinput"
            type="number"
            minLength={2}
            min="0"
            placeholder="Amount"
            onInput={(e)=>{
              console.log(e)
             }}
            ></input>
          <br></br>

          <select
            style={{
              width: "40%",
              border: "1px solid green",
              backgroundColor: "white",
            }} id="selectedcurrency">
              
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="NGN">NGN</option>
          </select>
        </div>
        <br></br>
        <br></br>
        <div id="buttonclub"> 
          <button onClick={()=>{
             var selectedcurrency =document.querySelector("#selectedcurrency").value
             sessionStorage.setItem("selectedcurrency",selectedcurrency);
             var Amount3=document.getElementById("searchinput").value
             sessionStorage.setItem("agreedamount",Amount3);
              
              console.log(selectedcurrency,Amount3)
              renderpaybutton()
          }}>Pay</button>
          <div>
              
          </div>
        
        </div>
       
      </div>
    </div>
  );
};

const Paybutton=()=>{
  var config = {
    public_key: "FLWPUBK-e523935dd997695c1162c2c6d908a0b5-X",
    tx_ref: Date.now(),
    amount: Number(sessionStorage.getItem("agreedamount"))+10,
    //  amount: 20,
    currency: sessionStorage.getItem("selectedcurrency"),
    payment_options: "card,mobilemoney,ussd,bank",
    customer: {
      email: "customer@gmail.com",
      phonenumber: sessionStorage.getItem("customernumber"),
      name: sessionStorage.getItem("customername"),
    },
    customizations: {
      title: "@Househelp.ng",
      description: "Payment househelp to @househelp.ng",
      logo: "https://react-househelp.netlify.app/static/media/logo.4c7277c6.png",
    },
  };
  var handleFlutterPayment = useFlutterwave(config);
  // 

  return(
    <div>
         <button
          onClick={() => {
           
           
         
              setTimeout(()=>{ console.log(config)
                 handleFlutterPayment({
                callback: (response) => {
                  console.log(response);
  
                  if (response.status == "successful") {
                    const db = getDatabase();
  
                    document.querySelector(".partpaymentdiv").style.display =
                      "none";
                    document.querySelector("#div43").style.display = "block";
                    closePaymentModal();
                  } else {
                    console.log("payment Failed");
                  }
  
                  // this will close the modal programmatically
                },
                onClose: () => {},
              });},3000)
          
           
          }}>
          Make Payments
        </button>
    </div>
  )
}

function renderAdmin() {
  reactDom.render(
    <React.StrictMode>
      <Header />
      <Assistant />
    </React.StrictMode>,
    document.querySelector("#root")
  );
}

function renderpaybutton() {
  reactDom.render(
    <React.StrictMode>
      <Paybutton></Paybutton>
    </React.StrictMode>,
    document.querySelector("#buttonclub")
  );
}

export { Assistant, Donate, LoginA };
